import Vue from 'vue'
import _debounce from 'lodash.debounce'

export default {
  namespaced: true,
  state: {
    selectedTab: null,
    selectedTabID: null,
    tabs: [],
    headers: [],
    items: [],
    total: 0,
    search: null,
    pagination: {
      sortBy: 'createdAt',
      descending: true,
      page: 1,
      rowsPerPage: 10
    },
    loading: false,
    restrictedHeaders: ['_id', 'cif_op', 'cif_os', 'denumire_apl', 'tip_apl', 'judet', 'capita', 'createdAt', 'updatedAt'],
    hookHeaders: ['createdAt', 'updatedAt'],
    minIndex: 9,
    unique: {},
    service: {
      path: 'cifuri',
      headers: 'cifuriheaders',
      tabs: 'cifuriperioade',
      upload: 'cifuri-upload',
      mainField: 'denumire_apl',
      tabField: 'perioada'
    },
    msgTemplates: {
      resource: 'municpii',
      main: 'denumire_apl'
    }
  },
  getters: {
    tabs: state => state.tabs,
    selectedTab: state => state.selectedTab,
    selectedTabID: state => state.selectedTabID,
    headers: state => state.headers,
    items: state => state.items,
    total: state => state.total,
    loading: state => state.loading,
    restrictedHeaders: state => state.restrictedHeaders,
    hookHeaders: state => state.hookHeaders,
    pagination: state => state.pagination,
    minIndex: state => state.minIndex,
    unique: state => state.unique,
    latestPerioada: state => {
      if (state.tabs.length) {
        const perioada = state.tabs.map(perioada => perioada.label).sort().pop()
        const parts = perioada.split('-')
        const q = +parts[1][1]
        return `${parts[0]}-0${q * 3}`
      }
      return null
    },
    search: state => state.search
  },
  mutations: {
    clearState (state) {
      state.tabs = []
      state.items = []
      state.headers = []
    },
    setSelectedTab (state, payload) {
      if (state.tabs.length && state.tabs[payload]) {
        state.selectedTab = payload
        state.selectedTabID = state.tabs[payload]._id
      }
    },
    setTabs (state, payload) {
      state.tabs = payload
      if (state.selectedTabID) {
        const pos = payload.findIndex(tab => tab._id === state.selectedTabID)
        if (pos > -1) {
          state.selectedTab = pos
        } else if (payload.length) {
          state.selectedTab = 0
          state.selectedTabID = payload[0]._id
        } else {
          state.selectedTab = null
          state.selectedTabID = null
        }
      } else if (payload.length) {
        state.selectedTab = 0
        state.selectedTabID = payload[0]._id
      } else {
        state.selectedTab = null
        state.selectedTabID = null
      }
    },
    setHeaders (state, payload) {
      Vue.set(state, 'headers', payload)
    },
    setItems (state, payload) {
      state.items = payload
    },
    setTotal (state, payload) {
      state.total = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setPagination (state, payload) {
      Vue.set(state, 'pagination', payload)
    },
    setSortBy (state, payload) {
      Vue.set(state.pagination, 'sortBy', payload)
    },
    clearUniques (state) {
      Vue.set(state, 'unique', {})
    },
    setUnique (state, payload) {
      const arr = payload.values.map(row => {
        return Object.values(row).join('')
      })
      Vue.set(state.unique, payload.head, arr)
    },
    setSearch (state, payload) {
      state.search = payload
    }
  },
  actions: {
    setEventWatchers ({ commit, dispatch, rootState }) {
      rootState.services.cifuri.events.forEach(event => {
        rootState.services.cifuri.on(event, data => {
          commit('setLoading', true)
          // dispatch('fetchTabs')
          dispatch('fetchHeaders')
          dispatch('fetchItems')
        })
      })
      rootState.services.cifuri.on('batchDeleteSuccess', data => {
        dispatch('fetchItems')
      })
      rootState.services.cifuriheaders.events.forEach(event => {
        rootState.services.cifuriheaders.on(event, data => {
          commit('setLoading', true)
          // dispatch('fetchTabs')
          dispatch('fetchHeaders')
          dispatch('fetchItems')
        })
      })
      rootState.services.cifuriperioade.events.forEach(event => {
        rootState.services.cifuriperioade.on(event, data => {
          commit('setLoading', true)
          dispatch('fetchTabs')
          // dispatch('fetchHeaders')
          // dispatch('fetchItems')
        })
      })
    },
    fetchTabs: _debounce(({ state, commit, rootState, dispatch }) => {
      commit('setLoading', true)
      rootState.feathers.service(state.service.tabs).find({
        query: {
          $paginate: false,
          $sort: {
            date: -1
          }
        }
      }).then(result => {
        // dispatch('saveMessage', {
        //   user: rootState.auth.user._id,
        //   text: `Citire perioade "${state.msgTemplates.resource}" reusita.`,
        //   timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
        //   type: 'info'
        // }, { root: true })

        commit('setTabs', result)
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la interogare perioade "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
        commit('setLoading', false)
      }).finally(() => {
        commit('setLoading', false)
      })
    }, 1000),
    fetchHeaders: _debounce(({ commit, rootState, state, dispatch }) => {
      commit('setLoading', true)
      rootState.feathers.service(state.service.headers).find({
        query: {
          $paginate: false,
          $sort: {
            index: 1
          },
          perioada: state.selectedTabID
        }
      }).then(result => {
        // dispatch('saveMessage', {
        //   user: rootState.auth.user._id,
        //   text: `Citire proprietati "${state.msgTemplates.resource}" reusita.`,
        //   timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
        //   type: 'info'
        // }, { root: true })

        commit('setHeaders', result)
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la interogare proprietati "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
        commit('setLoading', false)
      }).finally(() => {
        commit('setLoading', false)
      })
    }, 1000),
    fetchItems: _debounce(({ state, commit, rootState, dispatch }) => {
      commit('setLoading', true)
      if (!state.pagination.sortBy) {
        commit('setSortBy', 'createdAt')
      }

      let skip = 0

      let query = {}
      if (state.pagination.rowsPerPage === -1) {
        query = {
          $paginate: false
        }
      } else {
        skip = state.pagination.rowsPerPage * (state.pagination.page - 1)
        query = {
          $limit: state.pagination.rowsPerPage,
          $skip: skip
        }
      }

      query.$sort = {
        [state.pagination.sortBy || 'createdAt']: state.pagination.descending ? -1 : 1
      }

      if (state.search && state.search.length) {
        query.$search = state.search
      }

      query.perioada = state.selectedTabID
      query['tip_apl'] = 'Municipiu'

      rootState.feathers.service(state.service.path).find({ query }).then(result => {
        // dispatch('saveMessage', {
        //   user: rootState.auth.user._id,
        //   text: `Citire "${state.msgTemplates.resource}" reusita. Pagina: ${state.pagination.page}, Total: ${result.total || result.length || 0}`,
        //   timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
        //   type: 'info'
        // }, { root: true })

        if (state.pagination.rowsPerPage === -1) {
          commit('setItems', result)
          commit('setTotal', result.length)
        } else {
          commit('setItems', result.data)
          commit('setTotal', result.total)
        }

        const { page, ...pagination } = state.pagination
        if (page > 1 && skip > result.total) {
          pagination.page = 1
          dispatch('paginationChanged', pagination)
        }
      }).catch(err => {
        dispatch('saveMessage', {
          user: rootState.auth.user._id,
          text: `Eroare la interogare "${state.msgTemplates.resource}"... Detalii: ${err.message || err.error.message}`,
          timestamp: (new Date()).toLocaleDateString('ro-RO', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }),
          type: 'error'
        }, { root: true })
        commit('setLoading', false)
      }).finally(() => {
        commit('setLoading', false)
      })
    }, 1000),
    search ({ commit, dispatch }, payload) {
      commit('setSearch', payload)
      dispatch('fetchItems')
    },
    paginationChanged ({ commit, dispatch }, payload) {
      commit('setPagination', payload)
      dispatch('fetchItems')
    },
    setSelectedTab ({ state, commit, dispatch }, payload) {
      const pos = state.tabs.findIndex(tab => tab._id === payload)
      if (pos > -1) {
        commit('setItems', [])
        commit('setHeaders', [])
        commit('setSelectedTab', pos)
        dispatch('fetchHeaders')
        dispatch('fetchItems')
      }
    },

    compute ({ rootState }, payload) {
      rootState.services.computation.create(payload)
    }
  }
}
